import { useEffect, useState, useRef } from "react"

const useEventBusModal = (openEvent, closeEvent, deps = []) => {
  const [isOpen, setIsOpen] = useState(false)
  const [payload, setPayload] = useState(null)
  const [openTick, setOpenTick] = useState(0) // ← инкремент на каждый open

  useEffect(() => {
    const handleOpen = (data) => {
      setPayload(data)
      setIsOpen(true)
      setOpenTick((n) => n + 1) // ← всегда новое значение
    }

    const handleClose = () => {
      setIsOpen(false)
      setPayload(null)
    }

    window.EventBus?.on(openEvent, handleOpen)
    window.EventBus?.on(closeEvent, handleClose)

    return () => {
      window.EventBus?.off(openEvent, handleOpen)
      window.EventBus?.off(closeEvent, handleClose)
    }
  }, deps)

  return { isOpen, setIsOpen, payload, openTick } // ← экспортируем
}

export default useEventBusModal
